import * as React from "react";
const SvgFiRrMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-moon_svg__a)">
      <path
        fill="#062147"
        d="M15 24a12.02 12.02 0 0 1-8.914-3.966 11.9 11.9 0 0 1-3.02-9.309A12.12 12.12 0 0 1 13.085.152a13.1 13.1 0 0 1 5.03.205 2.5 2.5 0 0 1 1.109 4.226c-4.56 4.166-4.164 10.644.807 14.41a2.5 2.5 0 0 1-.7 4.32c-1.398.457-2.86.689-4.331.687m.076-22a11 11 0 0 0-1.677.127 10.09 10.09 0 0 0-8.344 8.8A9.93 9.93 0 0 0 7.572 18.7a10.48 10.48 0 0 0 11.092 2.73.5.5 0 0 0 .139-.857c-5.93-4.478-6.4-12.486-.948-17.449a.46.46 0 0 0 .128-.466.49.49 0 0 0-.356-.36A10.7 10.7 0 0 0 15.076 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-moon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMoon;
